import { render } from "./FrameJavaDebug.vue?vue&type=template&id=3eef38ec&scoped=true"
import script from "./FrameJavaDebug.vue?vue&type=script&lang=js"
export * from "./FrameJavaDebug.vue?vue&type=script&lang=js"

import "./FrameJavaDebug.vue?vue&type=style&index=0&id=3eef38ec&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eef38ec"]])

export default __exports__